export const FEATURED = 'featured';
